(function () {
    'use strict';

    /**
     * @ngdoc object
     * @name managePairing.controller:ManagePairingCtrl
     *
     * @description
     *
     */
    angular
        .module('managePairing')
        .controller('ManagePairingCtrl', ManagePairingCtrl);

    function ManagePairingCtrl(CommonMasterData, ManagePairing, MessageService, EventManagerService,ProfileService,
                               PopupManager, TabService, $stateParams, StorageServices, CreatePairing, $window,hotkeys) {
        var vm = this, lastDetelepairingMode = 'all';
        vm.view = ManagePairing.getView();
        vm.model = {
            editPairingMode:'',
            patternId: $stateParams.patternId,
            baseList: [],
            airCraftTypes: [],
            airportList: [],
            pairings: [],
            pairingValidity: [],
            commonSelectionCriteria:[],
            allPairings: [],
            searchParam: ManagePairing.pairingSearchCriteria(),
            viewMode: 'D',
            flightTotalRecords:1,
            bottomPanelShow:false,
            selectedPairings:[],
            selectedDisplayPairing:{},
            editPairing:false,
            requestOrigin: null,
            errorInfo: [],
            editCrewComplement: true,
            crewTypeList: [],
            currentCycle: null,
            syncingCrew: false
        };

        hotkeys.add({
        	combo: ['ctrl+a','ctrl+A'],
        	description: 'select all',
        	callback: function(event, hotkey) {
        		selectAllPairing();
        	}
        });

        hotkeys.add({
        	combo: 'del',
        	description: 'delete selected',
        	callback: function(event, hotkey) {
        		if(vm.model.searchParam.isModifiedFlight =='C'){
        			deleteSelection();
        		}
        	}
        });


        //Events
        EventManagerService.registerEventListener(EventManagerService.EVENT.TOOLBAR.VIEW_MODE_CHANGE, viewModeChanged);
        EventManagerService.registerEventListener(EventManagerService.EVENT.DO_ELASTIC_SEARCH, getNextSetOfRecords);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DELETE_BLOCK, deleteSelection);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.DESELECT_ALL, deSelectPairing);
        EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.GENERATE_PAIRING, generatePairingPopup);
        EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.ADD_PAIRING, addPairing);
        EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.AUTO_PAIRING, navigateToAutoPairing);
        EventManagerService.registerEventListener(EventManagerService.EVENT.CONTEXT_MENU.SELECT_ALL, selectAllPairing);
        EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.COPY_PAIRING, function(){
            vm.model.editPairingMode = 'copy';
            copyPairing()
        });
        EventManagerService.registerEventListener(EventManagerService.EVENT.MANAGE_PAIRING.DISCREPANCY_PAIRING, discrepancyPairing);


        vm.searchSubmit = function (searchParams) {
            searchPairings(searchParams);
        };

        vm.selectAPairing = function(event, pairing){
            vm.model.editPairing = false;
            if (pairing==='null'){
                ManagePairing.setSelectedPairings(pairing,ManagePairing.FLAGS.NEW);
            }else{
                if(event.ctrlKey){
                    ManagePairing.setSelectedPairings(pairing,ManagePairing.FLAGS.ADD_REMOVE);
                }else{
                    ManagePairing.setSelectedPairings(pairing,ManagePairing.FLAGS.NEW);
                }
            }
            vm.model.bottomPanelShow = true;
            vm.model.editCrewComplement = true;
            setSelectedPairings();
            if(pairing != "null"){
                updateRequiredList();
            }

        };

        vm.dblClickAPairing = function(event, pairing){
            ManagePairing.setSelectedPairings(pairing, ManagePairing.FLAGS.NEW);
            vm.model.bottomPanelShow = true;
            vm.model.editCrewComplement = true;
            setSelectedPairings();
            if(pairing != "null"){
                updateRequiredList();
            }

        };

        vm.toggleBottomPanel = function(){
            vm.model.bottomPanelShow = !vm.model.bottomPanelShow;
        };

        vm.editPairingOnClick = function(){
            if (ManagePairing.getSelectedPatternEditable(vm.model.selectedDisplayPairing)){
                vm.model.editPairing=true;
                enableCrewForEdit();
                editPairingContinueOnClick()
            }else{
                MessageService.warning('Pairing is not editable');
            }
        };
      vm.editCrewComplement = function(){
        vm.model.editCrewComplement = false;
        for (var i = 0; i < vm.model.crewTypeList.length; i++) {
            if(!checkIfCrewTypeCodeExists(vm.model.crewTypeList[i].crewTypeCode,vm.model.selectedDisplayPairing.crewRequirements)){
                vm.model.selectedDisplayPairing.crewRequirements.push({crewType:vm.model.crewTypeList[i].crewTypeCode, requiredCrew: 0, assingedCrew: 0, assignedName: []});
            }
        }
      }
      vm.saveCrewComplement = function(){
        var patternCrewDTOs = [];
        for(var i=0; i < vm.model.selectedDisplayPairing.crewRequirements.length; i++) {
            var obsCrew = 0;
            for(var j=0; j < vm.model.selectedDisplayPairing.crewRequirements[i].assignedName.length; j++) {
                if(vm.model.selectedDisplayPairing.crewRequirements[i].assignedName[j].isObsFlight == 'Y'){
                    obsCrew+=1;
                }
            }
            var patternCrewDTO = {
                crewTypeCode: vm.model.selectedDisplayPairing.crewRequirements[i].crewType,
                assignedCrew: parseInt(vm.model.selectedDisplayPairing.crewRequirements[i].assingedCrew),
                obsCrew: obsCrew
            };
            if(vm.model.selectedDisplayPairing.crewRequirements[i].requiredCrew != ''){
                patternCrewDTO.requiredCrew = parseInt(vm.model.selectedDisplayPairing.crewRequirements[i].requiredCrew);
            }else{
                patternCrewDTO.requiredCrew = null;
            }
            patternCrewDTOs.push(patternCrewDTO);

        }
        var param = {
            patternId: parseInt(vm.model.selectedDisplayPairing.patternId),
            patternCrewDTOs: patternCrewDTOs,
            isConfirm: 'N'
        };
        console.log(param);
        vm.model.editCrewComplement = true;
        ManagePairing.saveCrewComplement(param,
            function (response) {
                if (response.success){
                    MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                }else{
                    vm.model.errorInfo = [];
                    for(var i=0; i < response.errors.length; i++) {
                        if(response.errors[i] == "Crew is already assigned, please unassign the duty first to continue."){
                            MessageService.error(response.errors[i]);
                        }else{
                            vm.model.errorInfo.push(response.errors[i]);
                        }
                    }
                    if(vm.model.errorInfo.length > 0){
                        var MESSAGE = "";
                        for(var j=0; j < vm.model.errorInfo.length; j++) {
                            var error = vm.model.errorInfo[j].split(",");
                            MESSAGE += "Crew Type : " + error[0] + " Required Crew : " + error[1] + " Assigned Crew : " + error[2] + ". ";
                        }
                        MESSAGE += " Assigned Crew is greater than Required Crew. Do you want to continue? ";
                         var details = {
                            title: 'Confirmation',
                            messages: [MESSAGE]
                            };
                        PopupManager.openModal('CONFIRM_DIALOG', details, confirmSaveCrewComplement);
                    }
                }

                vm.model.searchParam.pairingName = vm.model.selectedDisplayPairing.patternName;
                ManagePairing.searchPairings(vm.model.searchParam,
                    function (crewReqResponse) {
                        for(var i=0; i < crewReqResponse[0].requiredList.length; i++) {
                            var current = crewReqResponse[0].requiredList[i];
                            var match = vm.model.selectedDisplayPairing.crewRequirements.find(function(req) {
                                return req.crewType === current.crewType;
                            });
                            if (match) {
                                match.requiredCrew = current.requiredCrew;
                            }
                        }
                    }, function (crewReqError) {
                        MessageService.error(crewReqError);
                    },
                true);
                var filteredCrewRequirements = [];
                for(var i=0; i < vm.model.selectedDisplayPairing.crewRequirements.length; i++) {
                    if(vm.model.selectedDisplayPairing.crewRequirements[i].requiredCrew > 0 || vm.model.selectedDisplayPairing.crewRequirements[i].assingedCrew > 0){
                        filteredCrewRequirements.push(vm.model.selectedDisplayPairing.crewRequirements[i]);
                    }
                }
                vm.model.selectedDisplayPairing.crewRequirements = filteredCrewRequirements;
            }, function (error) {
                MessageService.error(error);
        });
      };

      vm.syncCrew = function(){
        vm.model.syncingCrew = true;
        var param = {
            patternId: parseInt(vm.model.selectedDisplayPairing.patternId)
        };
        ManagePairing.syncCrew(param,
            function (response) {
                vm.model.syncingCrew = false;
                if (response.success){
                    if (response.queuedAssignCount === 0 && response.queuedUnassignCount === 0){
                        MessageService.success('Crew data is already up to date.');
                    }else{
                        var message = 'Sync triggered';
                        if (response.queuedAssignCount > 0) {
                            message += ' - ' + response.queuedAssignCount + ' crew member' + (response.queuedAssignCount === 1 ? '' : 's') + ' being synced';
                        }
                        if (response.queuedUnassignCount > 0) {
                            message += (response.queuedAssignCount > 0 ? ', ' : ' - ') + response.queuedUnassignCount + ' being removed';
                        }
                        message += '. Refreshing shortly.';
                        MessageService.success(message);
                        setTimeout(function(){
                            getCrewReqByPairingId();
                        }, 3000);
                    }
                }else{
                    MessageService.error(response.errors && response.errors.length ? response.errors[0] : 'Failed to sync crew.');
                }
                if (response.warnings && response.warnings.length){
                    for (var i = 0; i < response.warnings.length; i++) {
                        MessageService.warning(response.warnings[i]);
                    }
                }
            }, function (error) {
                vm.model.syncingCrew = false;
                MessageService.error(error);
            });
      };

      function updateRequiredList(){
        var filteredRequiredList = [];
        for(var i=0; i < vm.model.selectedDisplayPairing.requiredList.length; i++) {
            if(vm.model.selectedDisplayPairing.requiredList[i].requiredCrew > 0 || vm.model.selectedDisplayPairing.requiredList[i].assingedCrew > 0){
                filteredRequiredList.push(vm.model.selectedDisplayPairing.requiredList[i]);
            }
        }
        vm.model.selectedDisplayPairing.requiredList = filteredRequiredList;
      }

      function confirmSaveCrewComplement(pass){
        if(pass=='YES') {
            var patternCrewDTOs = [];
            for(var i=0; i < vm.model.errorInfo.length; i++) {
                var error = vm.model.errorInfo[i].split(",");
                patternCrewDTOs.push({crewTypeCode: error[0], requiredCrew: error[1], assignedCrew: error[2]});
            }
            var param = {
                patternId: parseInt(vm.model.selectedDisplayPairing.patternId),
                patternCrewDTOs: patternCrewDTOs,
                isConfirm: 'Y'
            };
            ManagePairing.saveCrewComplement(param,
                function (response) {
                    if (response.success){
                        MessageService.success(MessageService.MESSAGES.CREW_PROFILE.EDIT_SUCCESS);
                    }
                    vm.model.searchParam.pairingName = vm.model.selectedDisplayPairing.patternName;
                    ManagePairing.searchPairings(vm.model.searchParam,
                        function (crewReqResponse) {
                            for(var i=0; i < crewReqResponse[0].requiredList.length; i++) {
                                var current = crewReqResponse[0].requiredList[i];
                                var match = vm.model.selectedDisplayPairing.crewRequirements.find(function(req) {
                                    return req.crewType === current.crewType;
                                });
                                if (match) {
                                    match.requiredCrew = current.requiredCrew;
                                }
                            }
                        }, function (crewReqError) {
                            MessageService.error(crewReqError);
                        },
                    true);
                    var filteredCrewRequirements = [];
                    for(var i=0; i < vm.model.selectedDisplayPairing.crewRequirements.length; i++) {
                        if(vm.model.selectedDisplayPairing.crewRequirements[i].requiredCrew > 0 || vm.model.selectedDisplayPairing.crewRequirements[i].assingedCrew > 0){
                            filteredCrewRequirements.push(vm.model.selectedDisplayPairing.crewRequirements[i]);
                        }
                    }
                    vm.model.selectedDisplayPairing.crewRequirements = filteredCrewRequirements;
                }, function (error) {
                    MessageService.error(error);
                   });
        }
      }

      function editPairingContinueOnClick(){
        vm.model.editPairingMode = 'edit';
        copyPairing();
      }

        vm.deletePairings = function(flg){
            lastDetelepairingMode = flg;
            ManagePairing.deletePairings(lastDetelepairingMode,
                function (response) {
                    if (response.success){
                        MessageService.success('Successfully deleted!');
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.MANAGE_PAIRING.UPDATE_PAIRING_DATA, response.deletedPairings);
                        ManagePairing.setSelectedPairings('null',ManagePairing.FLAGS.NEW);
                        setSelectedPairings();
                    }else{
                        if(ManagePairing.isDeletePairingErrorByType("CREW_ASSIGNED_PATTERN", response.deletePatternErrors)){
                            var confirmDelete = {};
                            confirmDelete.title = "Delete Pairing";
                            confirmDelete.messages = [];
                            confirmDelete.messages[0] = "Crew assigned to this pattern";
                            confirmDelete.messages[1] = "Do you want to delete this?";
                                PopupManager.openModal('CONFIRM_DIALOG', confirmDelete, handelDeletePairing);
                        }else if(ManagePairing.isDeletePairingErrorByType("EXPIRIES_EXISTS", response.deletePatternErrors)){
                            MessageService.error("Expires exist for assigned crew");

                        }
                    }
                }, function (error) {
                    MessageService.error(error);
                });
        };

        vm.clearPairing = function (e) {
            vm.selectAPairing(e, 'null');
            vm.model.bottomPanelShow = false;
        };

        vm.openRoster = function (crew) {
          var _loadRosterParams = {
              fromDate : vm.model.currentCycle.dateFrom,
              toDate : vm.model.currentCycle.dateTo,
              crewId : crew.crewId
          };

          var navigateToRoster = function(paramToSend){
              var tabName = 'crewSchedule';
              StorageServices.setTabData(tabName,'crewingParams',paramToSend);
              TabService.gotoTab(tabName, {
                  crewId: paramToSend.crewId
              });
          };
          navigateToRoster(_loadRosterParams);
        };

        vm.checkPairingValidity = function(pairing) {
            if (!pairing) {
                return 'Invalid';
            }
            
            // First check if all blocks are legal
            if (pairing.isAllBlocksLegal !== 'Y') {
                return 'Invalid';
            }
            
            // Then check flight leg status for any cancelled flights
            if (pairing.blockList && pairing.blockList.length > 0) {
                for (var i = 0; i < pairing.blockList.length; i++) {
                    var block = pairing.blockList[i];
                    if (block.blockDetailList && block.blockDetailList.length > 0) {
                        for (var j = 0; j < block.blockDetailList.length; j++) {
                            var blockDetail = block.blockDetailList[j];
                            if (blockDetail.blockDetailType === 'FLIGHT' && 
                                blockDetail.flightLeg && 
                                blockDetail.flightLeg.flightLegStatus === 'CNX') {
                                return 'Invalid';
                            }
                        }
                    }
                }
            }
            
            return 'Valid';
        };

        function handelDeletePairing(pass){
            if(pass==="YES"){
                ManagePairing.setDeletePairingConfirm(true);
                vm.deletePairings(lastDetelepairingMode);
            }
        }

        function enableCrewForEdit(){
            angular.forEach(vm.model.selectedDisplayPairing.crewRequirements, function(crewType, k){
                angular.forEach(crewType.assignedName, function(crewName, i){
                    crewName.disabled=false;
                });
            });
        }

        function searchPairings(searchParams){
            vm.clearPairing();
            vm.model.flightTotalRecords = 1;
            vm.model.showSearchPanel = false;
            vm.model.searchParam = searchParams;
            ManagePairing.initPairingList();
            ManagePairing.searchPairings(searchParams,
                function (response) {
                    vm.model.flightTotalRecords =  ManagePairing.getNoOfItems();
                    vm.model.allPairings = [];
                    if (vm.model.patternId!==null && response.length>0){
                        for(var i=0;i<response.length;i++){
                            if (parseInt(response[i].patternId,10) === parseInt(vm.model.patternId,10)){
                                vm.model.allPairings.push(response[i]);
                            }
                        }
                        ManagePairing.setSelectedPairings(vm.model.allPairings[0],ManagePairing.FLAGS.NEW);
                        setSelectedPairings();
                        vm.model.bottomPanelShow = true;
                    }else{
                        vm.model.allPairings = response;
                    }
                }, function (error) {
                    MessageService.error(error);
                },true);
        }

        function addPairing(){
          console.log("add Pairning");
            vm.model.editPairingMode = 'new';
            TabService.gotoTab('createPairing', {mode:'new','pid':null});
        }

        function copyPairing(){
            var pairings = ManagePairing.getSelectedPairings();
            if (pairings.length>0){
                var tabName = 'createPairing';
                var pairing = pairings[pairings.length-1];
                var editPairingParams = {
                    pairingId: pairing.patternId,
                    startDate:pairing.startDate,
                    startTime:pairing.startTime,
                    endDate:pairing.endDate,
                    endTime:pairing.endTime,
                    crewRequirements:vm.model.selectedDisplayPairing.crewRequirements,
                    genderRequirements:vm.model.selectedDisplayPairing.genderRequirement,
                    requestOrigin :vm.model.requestOrigin,
                    editPairingMode :vm.model.editPairingMode
                };

                if(vm.model.editPairingMode==='edit'){
                    if(ManagePairing.checkCrewReqAvailability(vm.model.selectedDisplayPairing.crewRequirements)){
                        StorageServices.setTabData(tabName,'editPairingParams',editPairingParams);
                        TabService.gotoTab('createPairing', {'mode':vm.model.editPairingMode,'pid':pairing.patternId});
                    }else{
                        MessageService.warning('Select at least one crew to edit');
                    }
                }else{
                    StorageServices.setTabData(tabName,'editPairingParams',editPairingParams);
                    TabService.gotoTab('createPairing', {'mode':vm.model.editPairingMode,'pid':pairing.patternId});
                }
            }else{
                MessageService.warning('No pairing is selected, select a pairing');
            }
        }

      function navigateToAutoPairing(){
        $window.open(window.location.origin + "/react/#/flights/autoPairing");
      }

        function generatePairingPopup(){
            var pairings = ManagePairing.getSelectedPairings();
            if (pairings.length>0){
                if(pairings[0].patternId!==null && pairings[0].patternId!==""){
                    CreatePairing.loadPairingByID(pairings[0].patternId, 'add',
                        function(result){
                            CreatePairing.setLoadedPairingForSave(result);
                            var generatePairingModel = {};
                            generatePairingModel.pairingModel = result;
                            PopupManager.openModal('GENERATE_PAIRING', generatePairingModel, handelGeneratePairing);
                        },
                        function(error){
                            MessageService.error(error);
                        });
                }
            }else{
                MessageService.warning('No pairing is selected, select a pairing');
            }
        }

        function discrepancyPairing(){
            var pairings = ManagePairing.getSelectedPairings();
            if (pairings.length>0){

            }else{
                MessageService.warning('No pairing is selected, select a pairing');
            }
        }

        function checkIfCrewTypeCodeExists(crewTypeCode, crewTypeCodeArray) {
            for (var i = 0; i < crewTypeCodeArray.length; i++) {
                if (crewTypeCodeArray[i].crewType === crewTypeCode) {
                    return true;
                }
            }
            return false;
        }

        function setSelectedPairings(){
        	vm.model.selectedPairings = ManagePairing.getSelectedPairings();
        	ManagePairing.setDeletePairingConfirm(false);
        	if(vm.model.selectedPairings.length>0){
        		vm.model.selectedDisplayPairing = vm.model.selectedPairings[vm.model.selectedPairings.length-1];
        		vm.model.selectedDisplayPairing.langRequirements = [];
        		vm.model.selectedDisplayPairing.crewRequirements = [];
                vm.model.selectedDisplayPairing.genderRequirement = {};
        		/*ManagePairing.getCrewReqByPairingId(vm.model.selectedDisplayPairing,
        				function (response) {
        			vm.model.selectedDisplayPairing.crewRequirements = response;
        		}, function (error) {
        			MessageService.error(error);
        		});
        		ManagePairing.getLangReqByPairingId(vm.model.selectedDisplayPairing,
            			function (response) {
            		vm.model.selectedDisplayPairing.langRequirements = response;
        		}, function (error) {
            		MessageService.error(error);
            	})*/

        		/*$.when(getCrewReqByPairingId())
       		 	.then(function() {
       		 		getLangReqByPairingId();
				});*/

        		getCrewReqByPairingId();
        		getCycleFromDate(vm.model.selectedPairings[0].startDate);
        	}
        }

        function getCrewReqByPairingId(){

        	ManagePairing.getCrewReqByPairingId(vm.model.selectedDisplayPairing,
    				function (response) {
    			vm.model.selectedDisplayPairing.crewRequirements = response;
    			getLangReqByPairingId();
                getGenderReqByPairingId();
    		}, function (error) {
    			MessageService.error(error);
    		});

        }
        function getCycleFromDate(date){
          ManagePairing.getCycleFromDate(date,function (response) {
            vm.model.currentCycle = response;
          }, function (error) {
            MessageService.error(error);
          });
        }

        function getLangReqByPairingId(){
        	setTimeout(function(){
        		ManagePairing.getLangReqByPairingId(vm.model.selectedDisplayPairing,
        				function (response) {
        			vm.model.selectedDisplayPairing.langRequirements = response;
        		}, function (error) {
        			MessageService.error(error);
        		})
        	}, 100);
        }



      function getGenderReqByPairingId(){
        setTimeout(function(){
          ManagePairing.getGenderReqByPairingId(vm.model.selectedDisplayPairing,
            function (response) {
              vm.model.selectedDisplayPairing.genderRequirement = response;
              var foo = response.patternGenderDTO;
            }, function (error) {
              MessageService.error(error);
            })
        }, 100);
      }



        function viewModeChanged(data){
            if (data.view == vm.view) {
                vm.model.viewMode = data.mode;
                ManagePairing.setViewConfigByView(vm.model.viewMode);
            }
        }

        function handelGeneratePairing(pass){
            if (pass.save){
                CreatePairing.setPatternAsPairing(pass.pairingModel);
                CreatePairing.setCrewRequirementsForModifyPairing(vm.model.selectedDisplayPairing.crewRequirements);
                CreatePairing.pageMode = CreatePairing.LOADMODE.COPY;
                CreatePairing.saveDataForPairing(pass.pairingModel);
            }
        }

        function deleteSelection(){
            vm.model.selectedPairings = ManagePairing.getSelectedPairings();
            if(vm.model.selectedPairings.length>0){
                lastDetelepairingMode = 'all';
                ManagePairing.deletePairings(lastDetelepairingMode,
                    function (response) {
                        if(response.success){
                            MessageService.success('Successfully deleted!');
                            EventManagerService.notifyEventListeners(EventManagerService.EVENT.MANAGE_PAIRING.UPDATE_PAIRING_DATA, response.deletedPairings);
                            ManagePairing.setSelectedPairings('null',ManagePairing.FLAGS.NEW);
                            setSelectedPairings();
                        }else{
                            if(ManagePairing.isDeletePairingErrorByType("CREW_ASSIGNED_PATTERN", response.deletePatternErrors)){
                                var confirmDelete = {};
                                confirmDelete.title = "Delete Pairing";
                                confirmDelete.messages = [];
                                confirmDelete.messages[0] = "Crew assigned to this pattern";
                                confirmDelete.messages[1] = "Do you want to delete this?";
                                PopupManager.openModal('CONFIRM_DIALOG', confirmDelete, handelDeletePairing);
                            }else if(ManagePairing.isDeletePairingErrorByType("EXPIRIES_EXISTS", response.deletePatternErrors)){
                                MessageService.error("Expires exist for assigned crew");
                            }
                        }
                    }, function (error) {
                        MessageService.error(error);
                    });
            }
        }

        function deSelectPairing(){
            ManagePairing.setSelectedPairings('null',ManagePairing.FLAGS.NEW);
            setSelectedPairings();
        }

        function selectAllPairing(){
        	var filteredData = getFilteredData(ManagePairing.getPairingsList());
        	vm.filteredData = [];

        	angular.forEach(filteredData,function(data){
        		angular.forEach(data,function(obj){
        			vm.filteredData.push(obj);
            	});
        	});
        	ManagePairing.setSelectedPairings(vm.filteredData,ManagePairing.FLAGS.ALL);
        	setSelectedPairings();
        }

        function getFilteredData(dataToFilter){
            return _.groupBy(dataToFilter, 'startDate');
        }

        function getNextSetOfRecords(){
            vm.model.searchParam.startPosition = vm.model.searchParam.startPosition + vm.model.searchParam.pageSize;
            if(vm.model.searchParam.startPosition<vm.model.flightTotalRecords){
                EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                    flag: true,
                    target: 'managePairing',
                    animationName: 'crewing-loader'
                });
                ManagePairing.searchPairings(vm.model.searchParam,
                    function (searchResults) {
                        vm.model.flightTotalRecords =  ManagePairing.getNoOfItems();
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.MANAGE_PAIRING.APPEND_PAIRING_DATA, searchResults);
                        EventManagerService.notifyEventListeners(EventManagerService.EVENT.SHOW_HIDE_LOADING, {
                            flag: false,
                            target: 'managePairing',
                            animationName: 'crewing-loader'
                        });
                    },
                    function (error) {
                        MessageService.error(error);
                    }, false);
            }
        }

        function callLoadPairings(){
            if(vm.model.patternId!==null){
                var tabName = 'managePairing';
                var pairingTabData = StorageServices.getTabData(tabName);
                if(pairingTabData!==null && pairingTabData.hasOwnProperty('editPairingParams')){
                    var pairingData = pairingTabData.editPairingParams;
                    if (parseInt(vm.model.patternId,10) === parseInt(pairingData.patternId,10)){
                        var searchCriteria = vm.model.searchParam;
                        searchCriteria.base = pairingData.crewBase;
                        searchCriteria.fromDate = pairingData.patternStartDate;
                        searchCriteria.toDate = pairingData.patternStartDate;
                        searchCriteria.pairingName = pairingData.patternName;
                        vm.model.requestOrigin = pairingData.requestOrigin;
                        if(!!searchCriteria.isModifiedFlight && !!searchCriteria.isModifiedFlight.value ){
                        	searchCriteria.isModifiedFlight = searchCriteria.isModifiedFlight.value;
                        }
                        searchPairings(searchCriteria);
                    }
                }
            }
        }

        function init() {
            CommonMasterData.getAirportList(function (airportList) {
                vm.model.airportList = airportList;
            }, function (error) {

            });
            CommonMasterData.getAircraftModels(function (airCraftList) {
                vm.model.airCraftTypes = airCraftList;
            }, function (error) {

            });
            CommonMasterData.getCrewBaseList(function (baseList) {
                vm.model.baseList = baseList;
                ManagePairing.setViewConfigByView(vm.model.viewMode);
                callLoadPairings();
            }, function (error) {

            });

            CommonMasterData.getCrewTypeList(function (crewTypeList) {
                vm.model.crewTypeList = crewTypeList;
            }, function () {
                console.log('Crew Type list retrieval error');
            });
            vm.model.pairingValidity = ManagePairing.getSearchPairingsValidity();
            vm.model.commonSelectionCriteria = ManagePairing.getCommonSelections();
            vm.model.modifyFlightList = ManagePairing.getFlightModifyList();

            CommonMasterData.getACMITypesList(function (acmiCodeList) {
              var acmiTypesList = [
                {
                  value: 'ALL',
                  name: "all",
                  text: "All",
                  selected: false
                }
              ];

              angular.forEach(acmiCodeList,function(acmiCode){
                acmiTypesList.push({
                  value: acmiCode.acmiCode,
                  name: acmiCode.acmiCode,
                  text: acmiCode.acmiDescription,
                  selected: false
                });
              });

              vm.model.acmiTypesList = acmiTypesList;
            }, function (error) {

            });

            CommonMasterData.getBaseAirport(function(response){
                vm.model.searchParam.base = response;
            },function(){})

        }
        init();
    }
    $(window).resize(function(){
    	var height=($("header").height() + $(".tabbed-view-container").height())+"px";
    	$(".manage-pattern-view .canvas").css("top", height);
    });
}());
